import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/custom-inventory/")({
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith("custom-inventory")) {
      throw redirect({
        to: "/workspaces/$workspace_id/custom-inventory/devices",
        params: {
          workspace_id: params.workspace_id,
        },
      });
    }
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
});
